<script>
export default {
  name: 'BFormInput',

  inheritAttrs: false,

  props: {
    errors: {
      type: Array
    },
    hasError: {
      type: Boolean
    },
    help: {
      type: String
    },
    id: {
      type: String,
      required: true
    },
    isValid: {
      type: Boolean
    },
    label: {
      type: String,
      required: true
    },
    labelAfter: {
      type: String
    }
  },

  computed: {
    formFieldAttrs () {
      return {
        class: { 'has-error': this.hasError, 'is-valid': this.isValid },
        errors: this.errors,
        hasError: this.hasError,
        help: this.help,
        id: this.id,
        label: this.label,
        labelAfter: this.labelAfter
      }
    },
    listeners () {
      return {
        ...this.$listeners,
        change: event => this.$emit('change', this.$attrs.type === 'file' ? event.target.files : event.target.value, event),
        input: event => this.$emit('input', event.target.value, event)
      }
    }
  },

  methods: {
    /**
     * Programatically set focus
     */
    focus () {
      this.$refs.input.focus()
    }
  }
}
</script>

<style>
.form-input {
  display: block;
  flex-grow: 1;
  width: 100%;
  min-width: 0;
  padding: 8px 12px;

  font-style: italic;

  background: #fff;
  border: 2px solid var(--color-brand);
  border-radius: 0;
  box-shadow: none;
}

.form-input[disabled] {
  cursor: not-allowed;
}

.form-input--textarea {
  line-height: 1.4;
}

.form-input--select {
  appearance: none;
  padding-right: 32px;
  background: #fff url("~@/assets/form-dropdown.svg") right 8px center / 16px no-repeat;
}

.form-input--select::-ms-expand {
  display: none;
}

.form-field.has-error .form-input,
.form-field.is-valid .form-input {
  padding-right: 40px;
  background: #fff right 10px center / 20px no-repeat;
}

.form-field.has-error .form-input {
  background-image: url("~@/assets/form-error.svg");
}

.form-field.is-valid .form-input {
  background-image: url("~@/assets/form-success.svg");
}

.form-field.has-error .form-input--select,
.form-field.is-valid .form-input--select {
  padding-right: 65px;
  background-position:
    right 8px center,
    right 36px center;
  background-size:
    16px,
    20px;
}

.form-field.has-error .form-input--select {
  background-image:
    url("~@/assets/form-dropdown.svg"),
    url("~@/assets/form-error.svg");
}

.form-field.is-valid .form-input--select {
  background-image:
    url("~@/assets/form-dropdown.svg"),
    url("~@/assets/form-success.svg");
}

.form-input__label-after {
  margin: 0 0 0 15px;
  line-height: 1.2;
}
</style>
